function transcodeLanguage(language) {
  const languages = {
    pt: 'pt-BR',
    en: 'en',
    es: 'es',
  };

  return languages[language] || language;
}

export { transcodeLanguage };
